<kws-progress-bar></kws-progress-bar>
<div class="application__background" style="background-image: url('./assets/images/background.jpg')">
  <div class="application__background--blender"></div>
</div>
<div class="application__root">
  <router-outlet></router-outlet>
</div>
